module.exports = __webpack_public_path__ + "media/gifts/gift-halo-face-treatment-0fe735fe.png";